<template>
  <el-table-column
    prop="customers_count"
    sortable="custom"
    label="Vevők"
    show-overflow-tooltip
    min-width="160"
  >
    <template slot-scope="scope">
      <el-tag size="small" @click="goToPartners(scope.row.id)" style="cursor: pointer;">{{ scope.row.customers_count }} vevő <i class="el-icon-arrow-right"></i></el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'customers_count',
  methods: {
    goToPartners(id) {
      this.$router.push('/data/partners?customer_group_id=' + id);
    }
  },
};
</script>
